/**
 * @module
 * @description Content Modules
 */

import pageSidebar from './page/sidebar';
import navigation from './header/navigation';
import searchModal from './header/search';
import sticky from './header/sticky';
import modules from './modules/index';

const init = () => {
	pageSidebar();
	navigation();
	searchModal();
	sticky();
	modules();
};

export default init;
